import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-barcode-printer',
  templateUrl: './barcode-printer.component.html',
  styleUrls: ['./barcode-printer.component.scss']
})
export class BarcodePrinterComponent implements OnInit {

  @Input()  printcodes: any[] = [];
  @Input()  isMultiple:boolean = false;

  elementType = 'svg';
  value = 'someValue12340987';
  format = 'CODE128';
  lineColor = '#000000';
  width = 2;
  height = 40;
  swidth = 2; //small label without content
  sheight = 30; //small label without content
  bwidth = 2; //big label without content
  bheight = 40; //big label without content
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'start';
  textPosition = 'bottom';
  textMargin = 4;
  fontSize = 10;
  sfontSize = 11;
  background = '#ffffff';
  margin = 3;
  marginTop = 4;
  marginBottom = 3;
  marginLeft = 20;
  marginRight = 20;
  smarginLeft = 20;
  smarginRight = 20;
  bmarginLeft = 20;
  bmarginRight = 20;
  smargin = 1;
  bmargin = 2;
  smarginTop = 5;
  smarginBottom = 1;
  bmarginTop = 10;
  bmarginBottom = 10;
 
  //marginBottom1 = 180;

  constructor() {}

  ngOnInit(): void {
    console.log('Print Codes:', this.printcodes, this. printcodes.length);
    
    // Big Label with description content
      if (this.printcodes && this.printcodes.length == 1 && this.printcodes[0].isShow ) {
        console.log('Big Label with description content',this.printcodes[0]?.stockCodeBarcode?.length)
        // this.width = this.printcodes[0].stockCodeBarcode.length >= 12 ? 0.8 : 1;
        // this.height = this.printcodes[0].stockCodeBarcode.length >= 12 ? 28 : 18;

        // Keep bar width at the scannable minimum (>=2 px) regardless of payload
        // length — shrinking bars below ~0.8 px makes CODE128 unreadable after
        // Edge's print-time sub-pixel rounding.
        if (this.printcodes[0]?.stockCodeBarcode?.length >= 12 && this.printcodes[0]?.stockCodeBarcode?.length == 50) {
          this.width = 2;
          this.height = 50;
        } else if (this.printcodes[0]?.stockCodeBarcode?.length >= 12 && this.printcodes[0]?.stockCodeBarcode?.length < 50) {
          this.width = 2;
          this.height = 45;
        } else {
          this.width = 2;
          this.height = 40;
        }
      }

    // Bilg lable with without description content
    if (this.printcodes && !this.printcodes[0].isShow && !this.printcodes[0].isFlagSmall)  {
          console.log('Bilg lable with without description content',this.printcodes[0]?.stockCodeBarcode?.length)
          this.value = this.printcodes[0];
          // this.width = this.printcodes[0].stockCodeBarcode.length >= 12 ? 0.8 : 1;
          // this.height = this.printcodes[0].stockCodeBarcode.length >= 12 ? 28 : 18;
        }

    // Small label with multiple barcodes
    if (this.printcodes && this.printcodes[0].isFlagSmall ) {
          console.log('Small label along with multiple barcodes',this.printcodes[0]?.stockCodeBarcode?.length)
          // this.width = this.printcodes[0].stockCodeBarcode.length >= 12 ? 0.8 : 1;
          // this.height = this.printcodes[0].stockCodeBarcode.length >= 12 ? 28 : 18;
        }

  }

  ngOnChanges(changes:SimpleChanges){
    if (changes?.printcodes?.currentValue != changes?.printcodes?.previousValue) {    
      //  this.printcodes = changes?.printcodes?.currentValue;
      //  this.isMultiple = changes?.isMultiple?.currentValue;
    }
  
  }

}
